import React from "react";
import translations from "../../utils/language/translations.json";
import { useTranslation } from "react-i18next";
import "./AboutUs.scss";
import SeoHelmet from '../../Seo/SeoHelmet';
const AboutUs = () => {
  const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.AboutUs[key][currentLang];

  return (
    <section className="section min100">
       <SeoHelmet type="about" />
      <div className="contentfront">
        {/* Title Section */}
        <div className="about-header" style={{ gridColumn: "span 12" }}>
          <h1>{t("Title Welcome to CardsFolio: Empowering Collectors in the Digital Age")}</h1>
           <p className="intro-text">
          <div dangerouslySetInnerHTML={{ __html: t("Welcome to CardsFolio: Empowering Collectors in the Digital Age") }} />
       
          </p>
        </div>

        {/* About Sections */}
        <section className="about-container" style={{ gridColumn: "span 12" }}>
          {[
            { title: "Title The Collector's Dilemma", text: "The Collector's Dilemma" },
            { title: "Title Introducing CardsFolio", text: "Introducing CardsFolio" },
            { title: "Title Communication: The Heart of Collecting", text: "Communication: The Heart of Collecting" },
            { title: "Title Modern Marketplace", text: "Modern Marketplace" },
            { title: "Title Our Commitment to You", text: "Our Commitment to You" },
          ].map((section, index) => (
            <div key={index} className={`about-section ${index % 2 === 0 ? "light" : "dark"}`} style={{ gridColumn: "span 12" }}>
              <h2>{t(section.title)}</h2>
              <div dangerouslySetInnerHTML={{ __html: t(section.text) }} />
            </div>
          ))}
          
        </section>
      </div>
    </section>
  );
};

export default AboutUs;
